<template>
  <NuxtLink
  v-if="tag && tag.slug"
  :to="$localePath(`/blog/${tag.slug}`)"
  class="rounded-full mr-2 mb-2 sm:mb-0 bg-[#5a6ded] border-2 border-[#3645d0] hover:bg-[#3645d0] px-2 py-0 text-xs text-white inline-block font-semibold leading-6  no-underline"
  >
    {{ tag.title }}
  </NuxtLink>
</template>

<script setup>
const props = defineProps({
  tag: {
    type: Object,
    default: null
  }
})
</script>